// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qEz_","rootMobile":"styles_rootMobile__FH-1l"};